import React from 'react';

import { Form, Formik } from 'formik';
import { Modal, UiInput } from 'ui-kit';
import { Button } from 'ui-kit/Buttons';
import * as Yup from 'yup';

import { useSubmitSupportRequest } from './useSubmitSupportRequest';

export const SupportModalV1 = ({ onClose }: { onClose: () => void }) => {
  const submitSupportRequest = useSubmitSupportRequest();

  const validationSchema = Yup.object().shape({
    feedback: Yup.string()
      .min(5, 'Too short')
      .max(2000, 'Too long')
      .required('Feedback is required'),
  });

  const handleSupportSubmit = async (values: { feedback: string }, resetForm: () => void) => {
    const success = await submitSupportRequest(values.feedback, {});

    if (success) {
      resetForm();
      onClose();
    }
  };

  return (
    <Modal
      setIsOpen={onClose}
      headerText="We’re here to help"
      caption="Describe your issue or feedback and our team will get back to you shortly."
      showClose={true}
      className="z-[9999] flex w-full flex-col rounded-lg border border-pink-500 bg-background-canvas p-6 font-heebo text-white shadow-lg"
    >
      <Formik
        initialValues={{ feedback: '' }}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => handleSupportSubmit(values, resetForm)}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            <UiInput
              name="feedback"
              type="text"
              value={values.feedback}
              onChange={handleChange}
              placeholder="Write your message here..."
              variant="gray"
              size="extra-large"
              error={!!errors.feedback && touched.feedback}
              message={touched.feedback ? errors.feedback : ''}
              className="min-h-[160px] resize-none"
              containerClass="w-full"
              as="textarea"
            />

            <div className="mt-6 flex justify-end">
              <Button
                type="primary_green"
                label="Submit"
                className="bg-purple-600 text-white"
                buttonType="submit"
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
